exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3y2-q_CzC1YITIEDtX-IUI,._35WXVW2VlSBf5JBAejKLlt{width:32px;height:32px;display:inline-block}html[dir] ._3y2-q_CzC1YITIEDtX-IUI,html[dir] ._35WXVW2VlSBf5JBAejKLlt{background-color:transparent}._3y2-q_CzC1YITIEDtX-IUI{width:16px;height:16px}html[dir] .fPFlBAuQpX1HDftEw0nbj{margin:10px 10px 10px 10px}", ""]);
// Exports
exports.locals = {
	"extraSmallIcon": "_3y2-q_CzC1YITIEDtX-IUI",
	"icon": "_35WXVW2VlSBf5JBAejKLlt",
	"iconDefault": "fPFlBAuQpX1HDftEw0nbj"
};